import React from 'react'

function LogisticsView() {
    return (
        <div>LogisticsView</div>
    )
}

export default LogisticsView